import React from 'react';
import { contactInfo } from '../../data/homeData';
import './ContactSection.css';

const ContactSection = () => {
  return (
    <section id="contact" className="section-card contact-section">
      <h2 className="contact-title">
        <i className="fa-solid fa-envelope fa-lg orange-icon" /> Contact
      </h2>
      <div className="contact-content">
        <div className="contact-info">
          {contactInfo.map((contact, index) => (
            <p key={index}>
              <i className={`fa-${contact.type === 'email' ? 'solid' : 'brands'} ${contact.icon} orange-icon`} />
              {contact.label}: <a href={contact.href} target={contact.type !== 'email' ? '_blank' : undefined} rel={contact.type !== 'email' ? 'noopener noreferrer' : undefined}>
                {contact.value}
              </a>
            </p>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ContactSection;